/**
 * Returns the Peru states list to populate the select item.
 */
 export function gluky_addressfield_per_states_list() {
  let temporalStates = [];
  const states = {
    '01': 'Amazonas',
    '02': 'Áncash',
    '03': 'Apurímac',
    '04': 'Arequipa',
    '05': 'Ayacucho',
    '06': 'Cajamarca',
    '07': 'Callao',
    '08': 'Cusco',
    '09': 'Huancavelica',
    '10': 'Huanuco',
    '11': 'Ica',
    '12': 'Junín',
    '13': 'La Libertad',
    '14': 'Lambayeque',
    '15': 'Lima',
    '16': 'Loreto',
    '17': 'Madre de Dios',
    '18': 'Moquegua',
    '19': 'Pasco',
    '20': 'Piura',
    '21': 'Puno',
    '22': 'San Martín',
    '23': 'Tacna',
    '24': 'Tumbes',
    '25': 'Ucayali',
  }
  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Peru cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
 export function gluky_addressfield_per_cities_list($state_code) {
  let temporalCities = [];

  const $data = {
    "01": {
      '010101': 'Chachapoyas',
      '010102': 'Asuncion',
      '010103': 'Balsas',
      '010104': 'Cheto',
      '010105': 'Chiliquin',
      '010106': 'Chuquibamba',
      '010107': 'Granada',
      '010108': 'Huancas',
      '010109': 'La jalca',
      '010110': 'Leimebamba',
      '010111': 'Levanto',
      '010112': 'Magdalena',
      '010113': 'Mariscal castilla',
      '010114': 'Molinopampa',
      '010115': 'Montevideo',
      '010116': 'Olleros',
      '010117': 'Quinjalca',
      '010118': 'San francisco de daguas',
      '010119': 'San isidro de maino',
      '010120': 'Soloco',
      '010121': 'Sonche',
      '010200': 'Bagua',
      '010202': 'Aramango',
      '010203': 'Copallin',
      '010204': 'El parco',
      '010205': 'Imaza',
      '010206': 'La peca',
      '010300': 'Bongara',
      '010301': 'Jumbilla',
      '010302': 'Chisquilla',
      '010303': 'Churuja',
      '010304': 'Corosha',
      '010305': 'Cuispes',
      '010306': 'Florida',
      '010307': 'Jazan',
      '010308': 'Recta',
      '010309': 'San carlos',
      '010310': 'Shipasbamba',
      '010311': 'Valera',
      '010312': 'Yambrasbamba',
      '010400': 'Condorcanqui',
      '010401': 'Nieva',
      '010402': 'El cenepa',
      '010403': 'Rio santiago',
      '010501': 'Lamud',
      '010502': 'Camporredondo',
      '010503': 'Cocabamba',
      '010504': 'Colcamar',
      '010505': 'Conila',
      '010506': 'Inguilpata',
      '010507': 'Longuita',
      '010508': 'Lonya chico',
      '010509': 'Luya',
      '010510': 'Luya viejo',
      '010511': 'Maria',
      '010512': 'Ocalli',
      '010513': 'Ocumal',
      '010514': 'Pisuquia',
      '010515': 'Providencia',
      '010516': 'San cristobal',
      '010517': 'San francisco del yeso',
      '010518': 'San jeronimo',
      '010519': 'San juan de lopecancha',
      '010520': 'Santa catalina',
      '010521': 'Santo tomas',
      '010522': 'Tingo',
      '010523': 'Trita',
      '010600': 'Rodriguez de mendoza',
      '010601': 'San nicolas',
      '010602': 'Chirimoto',
      '010603': 'Cochamal',
      '010604': 'Huambo',
      '010605': 'Limabamba',
      '010606': 'Longar',
      '010607': 'Mariscal benavides',
      '010608': 'Milpuc',
      '010609': 'Omia',
      '010610': 'Santa rosa',
      '010611': 'Totora',
      '010612': 'Vista alegre',
      '010700': 'Utcubamba',
      '010701': 'Bagua grande',
      '010702': 'Cajaruro',
      '010703': 'Cumba',
      '010704': 'El milagro',
      '010705': 'Jamalca',
      '010706': 'Lonya grande',
      '010707': 'Yamon',
    },
    "02": {
      '020000': 'Ancash',
      '020100': 'Huaraz',
      '020102': 'Cochabamba',
      '020103': 'Colcabamba',
      '020104': 'Huanchay',
      '020105': 'Independencia',
      '020106': 'Jangas',
      '020107': 'La libertad',
      '020108': 'Olleros',
      '020109': 'Pampas',
      '020110': 'Pariacoto',
      '020111': 'Pira',
      '020112': 'Tarica',
      '020200': 'Aija',
      '020202': 'Coris',
      '020203': 'Huacllan',
      '020204': 'La merced',
      '020205': 'Succha',
      '020301': 'Llamellin',
      '020302': 'Aczo',
      '020303': 'Chaccho',
      '020304': 'Chingas',
      '020305': 'Mirgas',
      '020306': 'San juan de rontoy',
      '020400': 'Asuncion',
      '020401': 'Chacas',
      '020402': 'Acochaca',
      '020500': 'Bolognesi',
      '020501': 'Chiquian',
      '020502': 'Abelardo pardo lezameta',
      '020503': 'Antonio raymondi',
      '020504': 'Aquia',
      '020505': 'Cajacay',
      '020506': 'Canis',
      '020507': 'Colquioc',
      '020509': 'Huasta',
      '020510': 'Huayllacayan',
      '020511': 'La primavera',
      '020512': 'Mangas',
      '020513': 'Pacllon',
      '020514': 'San miguel de corpanqui',
      '020515': 'Ticllos',
      '020600': 'Carhuaz',
      '020602': 'Acopampa',
      '020603': 'Amashca',
      '020604': 'Anta',
      '020605': 'Ataquero',
      '020606': 'Marcara',
      '020607': 'Pariahuanca',
      '020608': 'San miguel de aco',
      '020609': 'Shilla',
      '020610': 'Tinco',
      '020611': 'Yungar',
      '020700': 'Carlos fermin fitzcarrald',
      '020701': 'San luis',
      '020702': 'San nicolas',
      '020703': 'Yauya',
      '020800': 'Casma',
      '020802': 'Buena vista alta',
      '020803': 'Comandante noel',
      '020804': 'Yautan',
      '020900': 'Corongo',
      '020902': 'Aco',
      '020903': 'Bambas',
      '020904': 'Cusca',
      '020905': 'La pampa',
      '020906': 'Yanac',
      '020907': 'Yupan',
      '021000': 'Huari',
      '021002': 'Anra',
      '021003': 'Cajay',
      '021004': 'Chavin de huantar',
      '021005': 'Huacachi',
      '021006': 'Huacchis',
      '021007': 'Huachis',
      '021008': 'Huantar',
      '021009': 'Masin',
      '021010': 'Paucas',
      '021011': 'Ponto',
      '021012': 'Rahuapampa',
      '021013': 'Rapayan',
      '021014': 'San marcos',
      '021015': 'San pedro de chana',
      '021016': 'Uco',
      '021100': 'Huarmey',
      '021102': 'Cochapeti',
      '021103': 'Culebras',
      '021104': 'Huayan',
      '021105': 'Malvas',
      '021200': 'Huaylas',
      '021201': 'Caraz',
      '021202': 'Huallanca',
      '021203': 'Huata',
      '021205': 'Mato',
      '021206': 'Pamparomas',
      '021207': 'Pueblo libre',
      '021208': 'Santa cruz',
      '021209': 'Santo toribio',
      '021210': 'Yuracmarca',
      '021300': 'Mariscal luzuriaga',
      '021301': 'Piscobamba',
      '021302': 'Casca',
      '021303': 'Eleazar guzman barron',
      '021304': 'Fidel olivas escudero',
      '021305': 'Llama',
      '021306': 'Llumpa',
      '021307': 'Lucma',
      '021308': 'Musga',
      '021400': 'Ocros',
      '021401': 'Ocros',
      '021402': 'Acas',
      '021403': 'Cajamarquilla',
      '021404': 'Carhuapampa',
      '021405': 'Cochas',
      '021406': 'Congas',
      '021407': 'Llipa',
      '021408': 'San cristobal de rajan',
      '021409': 'San pedro',
      '021410': 'Santiago de chilcas',
      '021500': 'Pallasca',
      '021501': 'Cabana',
      '021503': 'Conchucos',
      '021504': 'Huacaschuque',
      '021505': 'Huandoval',
      '021506': 'Lacabamba',
      '021507': 'Llapo',
      '021510': 'Santa rosa',
      '021511': 'Tauca',
      '021600': 'Pomabamba',
      '021602': 'Huayllan',
      '021603': 'Parobamba',
      '021604': 'Quinuabamba',
      '021700': 'Recuay',
      '021702': 'Catac',
      '021703': 'Cotaparaco',
      '021704': 'Huayllapampa',
      '021705': 'Llacllin',
      '021706': 'Marca',
      '021707': 'Pampas chico',
      '021708': 'Pararin',
      '021709': 'Tapacocha',
      '021710': 'Ticapampa',
      '021800': 'Santa',
      '021801': 'Chimbote',
      '021802': 'Caceres del peru',
      '021803': 'Coishco',
      '021804': 'Macate',
      '021805': 'Moro',
      '021806': 'Nepeña',
      '021807': 'Samanco',
      '021809': 'Nuevo chimbote',
      '021900': 'Sihuas',
      '021902': 'Acobamba',
      '021903': 'Alfonso ugarte',
      '021904': 'Cashapampa',
      '021905': 'Chingalpo',
      '021906': 'Huayllabamba',
      '021907': 'Quiches',
      '021908': 'Ragash',
      '021909': 'San juan',
      '021910': 'Sicsibamba',
      '022000': 'Yungay',
      '022002': 'Cascapara',
      '022003': 'Mancos',
      '022004': 'Matacoto',
      '022005': 'Quillo',
      '022006': 'Ranrahirca',
      '022007': 'Shupluy',
      '022008': 'Yanama',
    },
    "03": {
      '030000': 'Apurimac',
      '030100': 'Abancay',
      '030102': 'Chacoche',
      '030103': 'Circa',
      '030104': 'Curahuasi',
      '030105': 'Huanipaca',
      '030106': 'Lambrama',
      '030107': 'Pichirhua',
      '030108': 'San pedro de cachora',
      '030109': 'Tamburco',
      '030200': 'Andahuaylas',
      '030202': 'Andarapa',
      '030203': 'Chiara',
      '030204': 'Huancarama',
      '030205': 'Huancaray',
      '030206': 'Huayana',
      '030207': 'Kishuara',
      '030208': 'Pacobamba',
      '030209': 'Pacucha',
      '030210': 'Pampachiri',
      '030211': 'Pomacocha',
      '030212': 'San antonio de cachi',
      '030213': 'San jeronimo',
      '030214': 'San miguel de chaccrampa',
      '030215': 'Santa maria de chicmo',
      '030216': 'Talavera',
      '030217': 'Tumay huaraca',
      '030218': 'Turpo',
      '030219': 'Kaquiabamba',
      '030300': 'Antabamba',
      '030302': 'El oro',
      '030303': 'Huaquirca',
      '030304': 'Juan espinoza medrano',
      '030305': 'Oropesa',
      '030306': 'Pachaconas',
      '030307': 'Sabaino',
      '030400': 'Aymaraes',
      '030401': 'Chalhuanca',
      '030402': 'Capaya',
      '030403': 'Caraybamba',
      '030404': 'Chapimarca',
      '030405': 'Colcabamba',
      '030406': 'Cotaruse',
      '030407': 'Huayllo',
      '030408': 'Justo apu sahuaraura',
      '030409': 'Lucre',
      '030410': 'Pocohuanca',
      '030411': 'San juan de chacña',
      '030412': 'Sañayca',
      '030413': 'Soraya',
      '030414': 'Tapairihua',
      '030415': 'Tintay',
      '030416': 'Toraya',
      '030417': 'Yanaca',
      '030500': 'Cotabambas',
      '030501': 'Tambobamba',
      '030503': 'Coyllurqui',
      '030504': 'Haquira',
      '030505': 'Mara',
      '030506': 'Challhuahuacho',
      '030600': 'Chincheros',
      '030602': 'Anco_huallo',
      '030603': 'Cocharcas',
      '030604': 'Huaccana',
      '030605': 'Ocobamba',
      '030606': 'Ongoy',
      '030607': 'Uranmarca',
      '030608': 'Ranracancha',
      '030700': 'Grau',
      '030701': 'Chuquibambilla',
      '030702': 'Curpahuasi',
      '030703': 'Gamarra',
      '030704': 'Huayllati',
      '030705': 'Mamara',
      '030706': 'Micaela bastidas',
      '030707': 'Pataypampa',
      '030708': 'Progreso',
      '030709': 'San antonio',
      '030710': 'Santa rosa',
      '030711': 'Turpay',
      '030712': 'Vilcabamba',
      '030713': 'Virundo',
      '030714': 'Curasco',
    },
    "04": {
      '040100': 'Arequipa',
      '040102': 'Alto selva alegre',
      '040103': 'Cayma',
      '040104': 'Cerro colorado',
      '040105': 'Characato',
      '040106': 'Chiguata',
      '040107': 'Jacobo hunter',
      '040108': 'La joya',
      '040109': 'Mariano melgar',
      '040110': 'Miraflores',
      '040111': 'Mollebaya',
      '040112': 'Paucarpata',
      '040113': 'Pocsi',
      '040114': 'Polobaya',
      '040115': 'Quequeña',
      '040116': 'Sabandia',
      '040117': 'Sachaca',
      '040118': 'San juan de siguas',
      '040119': 'San juan de tarucani',
      '040120': 'Santa isabel de siguas',
      '040121': 'Santa rita de siguas',
      '040122': 'Socabaya',
      '040123': 'Tiabaya',
      '040124': 'Uchumayo',
      '040125': 'Vitor',
      '040126': 'Yanahuara',
      '040127': 'Yarabamba',
      '040128': 'Yura',
      '040129': 'Jose luis bustamante y rivero',
      '040200': 'Camana',
      '040202': 'Jose maria quimper',
      '040203': 'Mariano nicolas valcarcel',
      '040204': 'Mariscal caceres',
      '040205': 'Nicolas de pierola',
      '040206': 'Ocoña',
      '040207': 'Quilca',
      '040208': 'Samuel pastor',
      '040300': 'Caraveli',
      '040302': 'Acari',
      '040303': 'Atico',
      '040304': 'Atiquipa',
      '040305': 'Bella union',
      '040306': 'Cahuacho',
      '040307': 'Chala',
      '040308': 'Chaparra',
      '040309': 'Huanuhuanu',
      '040310': 'Jaqui',
      '040311': 'Lomas',
      '040312': 'Quicacha',
      '040313': 'Yauca',
      '040400': 'Castilla',
      '040401': 'Aplao',
      '040402': 'Andagua',
      '040403': 'Ayo',
      '040404': 'Chachas',
      '040405': 'Chilcaymarca',
      '040406': 'Choco',
      '040407': 'Huancarqui',
      '040408': 'Machaguay',
      '040409': 'Orcopampa',
      '040410': 'Pampacolca',
      '040411': 'Tipan',
      '040412': 'Uñon',
      '040413': 'Uraca',
      '040414': 'Viraco',
      '040500': 'Caylloma',
      '040501': 'Chivay',
      '040502': 'Achoma',
      '040503': 'Cabanaconde',
      '040504': 'Callalli',
      '040505': 'Caylloma',
      '040506': 'Coporaque',
      '040507': 'Huambo',
      '040508': 'Huanca',
      '040509': 'Ichupampa',
      '040510': 'Lari',
      '040511': 'Lluta',
      '040512': 'Maca',
      '040513': 'Madrigal',
      '040514': 'San antonio de chuca',
      '040515': 'Sibayo',
      '040516': 'Tapay',
      '040517': 'Tisco',
      '040518': 'Tuti',
      '040519': 'Yanque',
      '040520': 'Majes',
      '040600': 'Condesuyos',
      '040601': 'Chuquibamba',
      '040602': 'Andaray',
      '040603': 'Cayarani',
      '040604': 'Chichas',
      '040605': 'Iray',
      '040606': 'Rio grande',
      '040607': 'Salamanca',
      '040608': 'Yanaquihua',
      '040700': 'Islay',
      '040701': 'Mollendo',
      '040702': 'Cocachacra',
      '040703': 'Dean valdivia',
      '040704': 'Islay',
      '040705': 'Mejia',
      '040706': 'Punta de bombon',
      '040800': 'La union',
      '040801': 'Cotahuasi',
      '040802': 'Alca',
      '040803': 'Charcana',
      '040804': 'Huaynacotas',
      '040805': 'Pampamarca',
      '040806': 'Puyca',
      '040807': 'Quechualla',
      '040808': 'Sayla',
      '040809': 'Tauria',
      '040810': 'Tomepampa',
      '040811': 'Toro',
    },
    "05": {
      '050000': 'Ayacucho',
      '050100': 'Huamanga',
      '050101': 'Ayacucho',
      '050102': 'Acocro',
      '050103': 'Acos vinchos',
      '050104': 'Carmen alto',
      '050105': 'Chiara',
      '050106': 'Ocros',
      '050107': 'Pacaycasa',
      '050108': 'Quinua',
      '050109': 'San jose de ticllas',
      '050110': 'San juan bautista',
      '050111': 'Santiago de pischa',
      '050112': 'Socos',
      '050113': 'Tambillo',
      '050114': 'Vinchos',
      '050115': 'Jesus nazareno',
      '050200': 'Cangallo',
      '050202': 'Chuschi',
      '050203': 'Los morochucos',
      '050204': 'Maria parado de bellido',
      '050205': 'Paras',
      '050206': 'Totos',
      '050300': 'Huanca sancos',
      '050301': 'Sancos',
      '050302': 'Carapo',
      '050303': 'Sacsamarca',
      '050304': 'Santiago de lucanamarca',
      '050400': 'Huanta',
      '050402': 'Ayahuanco',
      '050403': 'Huamanguilla',
      '050404': 'Iguain',
      '050405': 'Luricocha',
      '050406': 'Santillana',
      '050407': 'Sivia',
      '050408': 'Llochegua',
      '050500': 'La mar',
      '050501': 'San miguel',
      '050502': 'Anco',
      '050503': 'Ayna',
      '050504': 'Chilcas',
      '050505': 'Chungui',
      '050506': 'Luis carranza',
      '050507': 'Santa rosa',
      '050508': 'Tambo',
      '050509': 'Samugari',
      '050600': 'Lucanas',
      '050601': 'Puquio',
      '050602': 'Aucara',
      '050603': 'Cabana',
      '050604': 'Carmen salcedo',
      '050605': 'Chaviña',
      '050606': 'Chipao',
      '050607': 'Huac-huas',
      '050608': 'Laramate',
      '050609': 'Leoncio prado',
      '050610': 'Llauta',
      '050611': 'Lucanas',
      '050612': 'Ocaña',
      '050613': 'Otoca',
      '050614': 'Saisa',
      '050615': 'San cristobal',
      '050616': 'San juan',
      '050617': 'San pedro',
      '050618': 'San pedro de palco',
      '050619': 'Sancos',
      '050620': 'Santa ana de huaycahuacho',
      '050621': 'Santa lucia',
      '050700': 'Parinacochas',
      '050701': 'Coracora',
      '050702': 'Chumpi',
      '050703': 'Coronel castañeda',
      '050704': 'Pacapausa',
      '050705': 'Pullo',
      '050706': 'Puyusca',
      '050707': 'San francisco de ravacayco',
      '050708': 'Upahuacho',
      '050800': 'Paucar del sara sara',
      '050801': 'Pausa',
      '050802': 'Colta',
      '050803': 'Corculla',
      '050804': 'Lampa',
      '050805': 'Marcabamba',
      '050806': 'Oyolo',
      '050807': 'Pararca',
      '050808': 'San javier de alpabamba',
      '050809': 'San jose de ushua',
      '050810': 'Sara sara',
      '050900': 'Sucre',
      '050901': 'Querobamba',
      '050902': 'Belen',
      '050903': 'Chalcos',
      '050904': 'Chilcayoc',
      '050905': 'Huacaña',
      '050906': 'Morcolla',
      '050907': 'Paico',
      '050908': 'San pedro de larcay',
      '050909': 'San salvador de quije',
      '050910': 'Santiago de paucaray',
      '050911': 'Soras',
      '051000': 'Victor fajardo',
      '051001': 'Huancapi',
      '051002': 'Alcamenca',
      '051003': 'Apongo',
      '051004': 'Asquipata',
      '051005': 'Canaria',
      '051006': 'Cayara',
      '051007': 'Colca',
      '051008': 'Huamanquiquia',
      '051009': 'Huancaraylla',
      '051010': 'Huaya',
      '051011': 'Sarhua',
      '051012': 'Vilcanchos',
      '051100': 'Vilcas huaman',
      '051102': 'Accomarca',
      '051103': 'Carhuanca',
      '051104': 'Concepcion',
      '051105': 'Huambalpa',
      '051106': 'Independencia',
      '051107': 'Saurama',
      '051108': 'Vischongo',
    },
    "06": {
      '060100': 'Cajamarca',
      '060102': 'Asuncion',
      '060103': 'Chetilla',
      '060104': 'Cospan',
      '060105': 'Encañada',
      '060106': 'Jesus',
      '060107': 'Llacanora',
      '060108': 'Los baños del inca',
      '060109': 'Magdalena',
      '060110': 'Matara',
      '060111': 'Namora',
      '060112': 'San juan',
      '060200': 'Cajabamba',
      '060202': 'Cachachi',
      '060203': 'Condebamba',
      '060204': 'Sitacocha',
      '060300': 'Celendin',
      '060302': 'Chumuch',
      '060303': 'Cortegana',
      '060304': 'Huasmin',
      '060305': 'Jorge chavez',
      '060306': 'Jose galvez',
      '060307': 'Miguel iglesias',
      '060308': 'Oxamarca',
      '060309': 'Sorochuco',
      '060310': 'Sucre',
      '060311': 'Utco',
      '060312': 'La libertad de pallan',
      '060400': 'Chota',
      '060402': 'Anguia',
      '060403': 'Chadin',
      '060404': 'Chiguirip',
      '060405': 'Chimban',
      '060406': 'Choropampa',
      '060407': 'Cochabamba',
      '060408': 'Conchan',
      '060409': 'Huambos',
      '060410': 'Lajas',
      '060411': 'Llama',
      '060412': 'Miracosta',
      '060413': 'Paccha',
      '060414': 'Pion',
      '060415': 'Querocoto',
      '060416': 'San juan de licupis',
      '060417': 'Tacabamba',
      '060418': 'Tocmoche',
      '060419': 'Chalamarca',
      '060500': 'Contumaza',
      '060502': 'Chilete',
      '060503': 'Cupisnique',
      '060504': 'Guzmango',
      '060505': 'San benito',
      '060506': 'Santa cruz de toled',
      '060507': 'Tantarica',
      '060508': 'Yonan',
      '060600': 'Cutervo',
      '060602': 'Callayuc',
      '060603': 'Choros',
      '060604': 'Cujillo',
      '060605': 'La ramada',
      '060606': 'Pimpingos',
      '060607': 'Querocotillo',
      '060608': 'San andres de cutervo',
      '060609': 'San juan de cutervo',
      '060610': 'San luis de lucma',
      '060611': 'Santa cruz',
      '060612': 'Santo domingo de la capilla',
      '060613': 'Santo tomas',
      '060614': 'Socota',
      '060615': 'Toribio casanova',
      '060700': 'Hualgayoc',
      '060701': 'Bambamarca',
      '060702': 'Chugur',
      '060703': 'Hualgayoc',
      '060800': 'Jaen',
      '060802': 'Bellavista',
      '060803': 'Chontali',
      '060804': 'Colasay',
      '060805': 'Huabal',
      '060806': 'Las pirias',
      '060807': 'Pomahuaca',
      '060808': 'Pucara',
      '060809': 'Sallique',
      '060810': 'San felipe',
      '060811': 'San jose del alto',
      '060812': 'Santa rosa',
      '060900': 'San ignacio',
      '060902': 'Chirinos',
      '060903': 'Huarango',
      '060904': 'La coipa',
      '060905': 'Namballe',
      '060906': 'San jose de lourdes',
      '060907': 'Tabaconas',
      '061000': 'San marcos',
      '061001': 'Pedro galvez',
      '061002': 'Chancay',
      '061003': 'Eduardo villanueva',
      '061004': 'Gregorio pita',
      '061005': 'Ichocan',
      '061006': 'Jose manuel quiroz',
      '061007': 'Jose sabogal',
      '061100': 'San miguel',
      '061102': 'Bolivar',
      '061103': 'Calquis',
      '061104': 'Catilluc',
      '061105': 'El prado',
      '061106': 'La florida',
      '061107': 'Llapa',
      '061108': 'Nanchoc',
      '061109': 'Niepos',
      '061110': 'San gregorio',
      '061111': 'San silvestre de cochan',
      '061112': 'Tongod',
      '061113': 'Union agua blanca',
      '061200': 'San pablo',
      '061202': 'San bernardino',
      '061203': 'San luis',
      '061204': 'Tumbaden',
      '061300': 'Santa cruz',
      '061302': 'Andabamba',
      '061303': 'Catache',
      '061304': 'Chancaybaños',
      '061305': 'La esperanza',
      '061306': 'Ninabamba',
      '061307': 'Pulan',
      '061308': 'Saucepampa',
      '061309': 'Sexi',
      '061310': 'Uticyacu',
      '061311': 'Yauyucan',
    },
    "07": {
      '070100': 'Callao',
      '070102': 'Bellavista',
      '070103': 'Carmen de la legua reynoso',
      '070104': 'La perla',
      '070105': 'La punta',
      '070106': 'Ventanilla',
    },
    "08": {
      '080100': 'Cusco',
      '080102': 'Ccorca',
      '080103': 'Poroy',
      '080104': 'San jeronimo',
      '080105': 'San sebastian',
      '080106': 'Santiago',
      '080107': 'Saylla',
      '080108': 'Wanchaq',
      '080200': 'Acomayo',
      '080202': 'Acopia',
      '080203': 'Acos',
      '080204': 'Mosoc llacta',
      '080205': 'Pomacanchi',
      '080206': 'Rondocan',
      '080207': 'Sangarara',
      '080300': 'Anta',
      '080302': 'Ancahuasi',
      '080303': 'Cachimayo',
      '080304': 'Chinchaypujio',
      '080305': 'Huarocondo',
      '080306': 'Limatambo',
      '080307': 'Mollepata',
      '080308': 'Pucyura',
      '080309': 'Zurite',
      '080400': 'Calca',
      '080402': 'Coya',
      '080403': 'Lamay',
      '080404': 'Lares',
      '080405': 'Pisac',
      '080406': 'San salvador',
      '080407': 'Taray',
      '080408': 'Yanatile',
      '080500': 'Canas',
      '080501': 'Yanaoca',
      '080502': 'Checca',
      '080503': 'Kunturkanki',
      '080504': 'Langui',
      '080505': 'Layo',
      '080506': 'Pampamarca',
      '080507': 'Quehue',
      '080508': 'Tupac amaru',
      '080600': 'Canchis',
      '080601': 'Sicuani',
      '080602': 'Checacupe',
      '080603': 'Combapata',
      '080604': 'Marangani',
      '080605': 'Pitumarca',
      '080606': 'San pablo',
      '080607': 'San pedro',
      '080608': 'Tinta',
      '080700': 'Chumbivilcas',
      '080701': 'Santo tomas',
      '080702': 'Capacmarca',
      '080703': 'Chamaca',
      '080704': 'Colquemarca',
      '080705': 'Livitaca',
      '080706': 'Llusco',
      '080707': 'Quiñota',
      '080708': 'Velille',
      '080800': 'Espinar',
      '080802': 'Condoroma',
      '080803': 'Coporaque',
      '080804': 'Ocoruro',
      '080805': 'Pallpata',
      '080806': 'Pichigua',
      '080807': 'Suyckutambo',
      '080808': 'Alto pichigua',
      '080900': 'La convencion',
      '080901': 'Santa ana',
      '080902': 'Echarate',
      '080903': 'Huayopata',
      '080904': 'Maranura',
      '080905': 'Ocobamba',
      '080906': 'Quellouno',
      '080907': 'Kimbiri',
      '080908': 'Santa teresa',
      '080909': 'Vilcabamba',
      '080910': 'Pichari',
      '081000': 'Paruro',
      '081002': 'Accha',
      '081003': 'Ccapi',
      '081004': 'Colcha',
      '081005': 'Huanoquite',
      '081006': 'Omacha',
      '081007': 'Paccaritambo',
      '081008': 'Pillpinto',
      '081009': 'Yaurisque',
      '081100': 'Paucartambo',
      '081102': 'Caicay',
      '081103': 'Challabamba',
      '081104': 'Colquepata',
      '081105': 'Huancarani',
      '081106': 'Kosñipata',
      '081200': 'Quispicanchi',
      '081201': 'Urcos',
      '081202': 'Andahuaylillas',
      '081203': 'Camanti',
      '081204': 'Ccarhuayo',
      '081205': 'Ccatca',
      '081206': 'Cusipata',
      '081207': 'Huaro',
      '081208': 'Lucre',
      '081209': 'Marcapata',
      '081210': 'Ocongate',
      '081211': 'Oropesa',
      '081212': 'Quiquijana',
      '081300': 'Urubamba',
      '081302': 'Chinchero',
      '081303': 'Huayllabamba',
      '081304': 'Machupicchu',
      '081305': 'Maras',
      '081306': 'Ollantaytambo',
      '081307': 'Yucay',
    },
    "09": {
      '090100': 'Huancavelica',
      '090102': 'Acobambilla',
      '090103': 'Acoria',
      '090104': 'Conayca',
      '090105': 'Cuenca',
      '090106': 'Huachocolpa',
      '090107': 'Huayllahuara',
      '090108': 'Izcuchaca',
      '090109': 'Laria',
      '090110': 'Manta',
      '090111': 'Mariscal caceres',
      '090112': 'Moya',
      '090113': 'Nuevo occoro',
      '090114': 'Palca',
      '090115': 'Pilchaca',
      '090116': 'Vilca',
      '090117': 'Yauli',
      '090118': 'Ascension',
      '090119': 'Huando',
      '090200': 'Acobamba',
      '090202': 'Andabamba',
      '090203': 'Anta',
      '090204': 'Caja',
      '090205': 'Marcas',
      '090206': 'Paucara',
      '090207': 'Pomacocha',
      '090208': 'Rosario',
      '090300': 'Angaraes',
      '090301': 'Lircay',
      '090302': 'Anchonga',
      '090303': 'Callanmarca',
      '090304': 'Ccochaccasa',
      '090305': 'Chincho',
      '090306': 'Congalla',
      '090307': 'Huanca-huanca',
      '090308': 'Huayllay grande',
      '090309': 'Julcamarca',
      '090310': 'San antonio de antaparco',
      '090311': 'Santo tomas de pata',
      '090312': 'Secclla',
      '090400': 'Castrovirreyna',
      '090402': 'Arma',
      '090403': 'Aurahua',
      '090404': 'Capillas',
      '090405': 'Chupamarca',
      '090406': 'Cocas',
      '090407': 'Huachos',
      '090408': 'Huamatambo',
      '090409': 'Mollepampa',
      '090410': 'San juan',
      '090411': 'Santa ana',
      '090412': 'Tantara',
      '090413': 'Ticrapo',
      '090500': 'Churcampa',
      '090502': 'Anco',
      '090503': 'Chinchihuasi',
      '090504': 'El carmen',
      '090505': 'La merced',
      '090506': 'Locroja',
      '090507': 'Paucarbamba',
      '090508': 'San miguel de mayocc',
      '090509': 'San pedro de coris',
      '090510': 'Pachamarca',
      '090511': 'Cosme',
      '090600': 'Huaytara',
      '090602': 'Ayavi',
      '090603': 'Cordova',
      '090604': 'Huayacundo arma',
      '090605': 'Laramarca',
      '090606': 'Ocoyo',
      '090607': 'Pilpichaca',
      '090608': 'Querco',
      '090609': 'Quito-arma',
      '090610': 'San antonio de cusicancha',
      '090611': 'San francisco de sangayaico',
      '090612': 'San isidro',
      '090613': 'Santiago de chocorvos',
      '090614': 'Santiago de quirahuara',
      '090615': 'Santo domingo de capillas',
      '090616': 'Tambo',
      '090700': 'Tayacaja',
      '090701': 'Pampas',
      '090702': 'Acostambo',
      '090703': 'Acraquia',
      '090704': 'Ahuaycha',
      '090705': 'Colcabamba',
      '090706': 'Daniel hernandez',
      '090707': 'Huachocolpa',
      '090709': 'Huaribamba',
      '090710': 'Ñahuimpuquio',
      '090711': 'Pazos',
      '090713': 'Quishuar',
      '090714': 'Salcabamba',
      '090715': 'Salcahuasi',
      '090716': 'San marcos de rocchac',
      '090717': 'Surcubamba',
      '090718': 'Tintay puncu',
    },
    "10": {
      '100100': 'Huanuco',
      '100102': 'Amarilis',
      '100103': 'Chinchao',
      '100104': 'Churubamba',
      '100105': 'Margos',
      '100106': 'Quisqui (kichki)',
      '100107': 'San francisco de cayran',
      '100108': 'San pedro de chaulan',
      '100109': 'Santa maria del valle',
      '100110': 'Yarumayo',
      '100111': 'Pillco marca',
      '100112': 'Yacus',
      '100200': 'Ambo',
      '100202': 'Cayna',
      '100203': 'Colpas',
      '100204': 'Conchamarca',
      '100205': 'Huacar',
      '100206': 'San francisco',
      '100207': 'San rafael',
      '100208': 'Tomay kichwa',
      '100300': 'Dos de mayo',
      '100301': 'La union',
      '100307': 'Chuquis',
      '100311': 'Marias',
      '100313': 'Pachas',
      '100316': 'Quivilla',
      '100317': 'Ripan',
      '100321': 'Shunqui',
      '100322': 'Sillapata',
      '100323': 'Yanas',
      '100400': 'Huacaybamba',
      '100402': 'Canchabamba',
      '100403': 'Cochabamba',
      '100404': 'Pinra',
      '100500': 'Huamalies',
      '100501': 'Llata',
      '100502': 'Arancay',
      '100503': 'Chavin de pariarca',
      '100504': 'Jacas grande',
      '100505': 'Jircan',
      '100506': 'Miraflores',
      '100507': 'Monzon',
      '100508': 'Punchao',
      '100509': 'Puños',
      '100510': 'Singa',
      '100511': 'Tantamayo',
      '100600': 'Leoncio prado',
      '100601': 'Rupa-rupa',
      '100602': 'Daniel alomia robles',
      '100603': 'Hermilio valdizan',
      '100604': 'Jose crespo y castillo',
      '100605': 'Luyando',
      '100606': 'Mariano damaso beraun',
      '100700': 'Marañon',
      '100701': 'Huacrachuco',
      '100702': 'Cholon',
      '100703': 'San buenaventura',
      '100800': 'Pachitea',
      '100801': 'Panao',
      '100802': 'Chaglla',
      '100803': 'Molino',
      '100804': 'Umari',
      '100900': 'Puerto inca',
      '100902': 'Codo del pozuzo',
      '100903': 'Honoria',
      '100904': 'Tournavista',
      '100905': 'Yuyapichis',
      '101000': 'Lauricocha',
      '101001': 'Jesus',
      '101002': 'Baños',
      '101003': 'Jivia',
      '101004': 'Queropalca',
      '101005': 'Rondos',
      '101006': 'San francisco de asis',
      '101007': 'San miguel de cauri',
      '101100': 'Yarowilca',
      '101101': 'Chavinillo',
      '101102': 'Cahuac',
      '101103': 'Chacabamba',
      '101104': 'Aparicio pomares',
      '101105': 'Jacas chico',
      '101106': 'Obas',
      '101107': 'Pampamarca',
      '101108': 'Choras',
    },
    "11": {
      '110000': 'Ica',
      '110102': 'La tinguiña',
      '110103': 'Los aquijes',
      '110104': 'Ocucaje',
      '110105': 'Pachacutec',
      '110106': 'Parcona',
      '110107': 'Pueblo nuevo',
      '110108': 'Salas',
      '110109': 'San jose de los molinos',
      '110110': 'San juan bautista',
      '110111': 'Santiago',
      '110112': 'Subtanjalla',
      '110113': 'Tate',
      '110114': 'Yauca del rosario',
      '110200': 'Chincha',
      '110201': 'Chincha alta',
      '110202': 'Alto laran',
      '110203': 'Chavin',
      '110204': 'Chincha baja',
      '110205': 'El carmen',
      '110206': 'Grocio prado',
      '110207': 'Pueblo nuevo',
      '110208': 'San juan de yanac',
      '110209': 'San pedro de huacarpana',
      '110210': 'Sunampe',
      '110211': 'Tambo de mora',
      '110300': 'Nazca',
      '110302': 'Changuillo',
      '110303': 'El ingenio',
      '110304': 'Marcona',
      '110305': 'Vista alegre',
      '110400': 'Palpa',
      '110402': 'Llipata',
      '110403': 'Rio grande',
      '110404': 'Santa cruz',
      '110405': 'Tibillo',
      '110500': 'Pisco',
      '110502': 'Huancano',
      '110503': 'Humay',
      '110504': 'Independencia',
      '110505': 'Paracas',
      '110506': 'San andres',
      '110507': 'San clemente',
      '110508': 'Tupac amaru inca',
    },
    "12": {
      '120000': 'Junin',
      '120100': 'Huancayo',
      '120104': 'Carhuacallanga',
      '120105': 'Chacapampa',
      '120106': 'Chicche',
      '120107': 'Chilca',
      '120108': 'Chongos alto',
      '120111': 'Chupuro',
      '120112': 'Colca',
      '120113': 'Cullhuas',
      '120114': 'El tambo',
      '120116': 'Huacrapuquio',
      '120117': 'Hualhuas',
      '120119': 'Huancan',
      '120120': 'Huasicancha',
      '120121': 'Huayucachi',
      '120122': 'Ingenio',
      '120124': 'Pariahuanca',
      '120125': 'Pilcomayo',
      '120126': 'Pucara',
      '120127': 'Quichuay',
      '120128': 'Quilcas',
      '120129': 'San agustin',
      '120130': 'San jeronimo de tunan',
      '120132': 'Saño',
      '120133': 'Sapallanga',
      '120134': 'Sicaya',
      '120135': 'Santo domingo de acobamba',
      '120136': 'Viques',
      '120200': 'Concepcion',
      '120202': 'Aco',
      '120203': 'Andamarca',
      '120204': 'Chambara',
      '120205': 'Cochas',
      '120206': 'Comas',
      '120207': 'Heroinas toledo',
      '120208': 'Manzanares',
      '120209': 'Mariscal castilla',
      '120210': 'Matahuasi',
      '120211': 'Mito',
      '120212': 'Nueve de julio',
      '120213': 'Orcotuna',
      '120214': 'San jose de quero',
      '120215': 'Santa rosa de ocopa',
      '120300': 'Chanchamayo',
      '120302': 'Perene',
      '120303': 'Pichanaqui',
      '120304': 'San luis de shuaro',
      '120305': 'San ramon',
      '120306': 'Vitoc',
      '120400': 'Jauja',
      '120402': 'Acolla',
      '120403': 'Apata',
      '120404': 'Ataura',
      '120405': 'Canchayllo',
      '120406': 'Curicaca',
      '120407': 'El mantaro',
      '120408': 'Huamali',
      '120409': 'Huaripampa',
      '120410': 'Huertas',
      '120411': 'Janjaillo',
      '120412': 'Julcan',
      '120413': 'Leonor ordoñez',
      '120414': 'Llocllapampa',
      '120415': 'Marco',
      '120416': 'Masma',
      '120417': 'Masma chicche',
      '120418': 'Molinos',
      '120419': 'Monobamba',
      '120420': 'Muqui',
      '120421': 'Muquiyauyo',
      '120422': 'Paca',
      '120423': 'Paccha',
      '120424': 'Pancan',
      '120425': 'Parco',
      '120426': 'Pomacancha',
      '120427': 'Ricran',
      '120428': 'San lorenzo',
      '120429': 'San pedro de chunan',
      '120430': 'Sausa',
      '120431': 'Sincos',
      '120432': 'Tunan marca',
      '120433': 'Yauli',
      '120434': 'Yauyos',
      '120500': 'Junin',
      '120502': 'Carhuamayo',
      '120503': 'Ondores',
      '120504': 'Ulcumayo',
      '120600': 'Satipo',
      '120602': 'Coviriali',
      '120603': 'Llaylla',
      '120605': 'Pampa hermosa',
      '120607': 'Rio negro',
      '120608': 'Rio tambo',
      '120699': 'Mazamari - pangoa',
      '120700': 'Tarma',
      '120702': 'Acobamba',
      '120703': 'Huaricolca',
      '120704': 'Huasahuasi',
      '120705': 'La union',
      '120706': 'Palca',
      '120707': 'Palcamayo',
      '120708': 'San pedro de cajas',
      '120709': 'Tapo',
      '120800': 'Yauli',
      '120801': 'La oroya',
      '120802': 'Chacapalpa',
      '120803': 'Huay-huay',
      '120804': 'Marcapomacocha',
      '120805': 'Morococha',
      '120806': 'Paccha',
      '120807': 'Santa barbara de carhuacayan',
      '120808': 'Santa rosa de sacco',
      '120809': 'Suitucancha',
      '120810': 'Yauli',
      '120900': 'Chupaca',
      '120902': 'Ahuac',
      '120903': 'Chongos bajo',
      '120904': 'Huachac',
      '120905': 'Huamancaca chico',
      '120906': 'San juan de iscos',
      '120907': 'San juan de jarpa',
      '120908': 'Tres de diciembre',
      '120909': 'Yanacancha',
    },
    "13": {
      '130000': 'La libertad',
      '130100': 'Trujillo',
      '130102': 'El porvenir',
      '130103': 'Florencia de mora',
      '130104': 'Huanchaco',
      '130105': 'La esperanza',
      '130106': 'Laredo',
      '130107': 'Moche',
      '130108': 'Poroto',
      '130109': 'Salaverry',
      '130110': 'Simbal',
      '130111': 'Victor larco herrera',
      '130200': 'Ascope',
      '130202': 'Chicama',
      '130203': 'Chocope',
      '130204': 'Magdalena de cao',
      '130205': 'Paijan',
      '130206': 'Razuri',
      '130207': 'Santiago de cao',
      '130208': 'Casa grande',
      '130300': 'Bolivar',
      '130302': 'Bambamarca',
      '130303': 'Condormarca',
      '130304': 'Longotea',
      '130305': 'Uchumarca',
      '130306': 'Ucuncha',
      '130400': 'Chepen',
      '130402': 'Pacanga',
      '130403': 'Pueblo nuevo',
      '130500': 'Julcan',
      '130502': 'Calamarca',
      '130503': 'Carabamba',
      '130504': 'Huaso',
      '130600': 'Otuzco',
      '130602': 'Agallpampa',
      '130604': 'Charat',
      '130605': 'Huaranchal',
      '130606': 'La cuesta',
      '130608': 'Mache',
      '130610': 'Paranday',
      '130611': 'Salpo',
      '130613': 'Sinsicap',
      '130614': 'Usquil',
      '130700': 'Pacasmayo',
      '130701': 'San pedro de lloc',
      '130702': 'Guadalupe',
      '130703': 'Jequetepeque',
      '130704': 'Pacasmayo',
      '130705': 'San jose',
      '130800': 'Pataz',
      '130801': 'Tayabamba',
      '130802': 'Buldibuyo',
      '130803': 'Chillia',
      '130804': 'Huancaspata',
      '130805': 'Huaylillas',
      '130806': 'Huayo',
      '130807': 'Ongon',
      '130808': 'Parcoy',
      '130809': 'Pataz',
      '130810': 'Pias',
      '130811': 'Santiago de challas',
      '130812': 'Taurija',
      '130813': 'Urpay',
      '130900': 'Sanchez carrion',
      '130901': 'Huamachuco',
      '130902': 'Chugay',
      '130903': 'Cochorco',
      '130904': 'Curgos',
      '130905': 'Marcabal',
      '130906': 'Sanagoran',
      '130907': 'Sarin',
      '130908': 'Sartimbamba',
      '131000': 'Santiago de chuco',
      '131002': 'Angasmarca',
      '131003': 'Cachicadan',
      '131004': 'Mollebamba',
      '131005': 'Mollepata',
      '131006': 'Quiruvilca',
      '131007': 'Santa cruz de chuca',
      '131008': 'Sitabamba',
      '131100': 'Gran chimu',
      '131101': 'Cascas',
      '131102': 'Lucma',
      '131103': 'Marmot',
      '131104': 'Sayapullo',
      '131200': 'Viru',
      '131202': 'Chao',
      '131203': 'Guadalupito',
    },
    "14": {
      '140100': 'Chiclayo',
      '140102': 'Chongoyape',
      '140103': 'Eten',
      '140104': 'Eten puerto',
      '140105': 'Jose leonardo ortiz',
      '140106': 'La victoria',
      '140107': 'Lagunas',
      '140108': 'Monsefu',
      '140109': 'Nueva arica',
      '140110': 'Oyotun',
      '140111': 'Picsi',
      '140112': 'Pimentel',
      '140113': 'Reque',
      '140114': 'Santa rosa',
      '140115': 'Saña',
      '140116': 'Cayalti',
      '140117': 'Patapo',
      '140118': 'Pomalca',
      '140119': 'Pucala',
      '140120': 'Tuman',
      '140200': 'Ferreñafe',
      '140202': 'Cañaris',
      '140203': 'Incahuasi',
      '140204': 'Manuel antonio mesones muro',
      '140205': 'Pitipo',
      '140206': 'Pueblo nuevo',
      '140300': 'Lambayeque',
      '140302': 'Chochope',
      '140303': 'Illimo',
      '140304': 'Jayanca',
      '140305': 'Mochumi',
      '140306': 'Morrope',
      '140307': 'Motupe',
      '140308': 'Olmos',
      '140309': 'Pacora',
      '140310': 'Salas',
      '140311': 'San jose',
      '140312': 'Tucume',
    },
    "15": {
      '150100': 'Lima',
      '150102': 'Ancon',
      '150103': 'Ate',
      '150104': 'Barranco',
      '150105': 'Breña',
      '150106': 'Carabayllo',
      '150107': 'Chaclacayo',
      '150108': 'Chorrillos',
      '150109': 'Cieneguilla',
      '150110': 'Comas',
      '150111': 'El agustino',
      '150112': 'Independencia',
      '150113': 'Jesus maria',
      '150114': 'La molina',
      '150115': 'La victoria',
      '150116': 'Lince',
      '150117': 'Los olivos',
      '150118': 'Lurigancho',
      '150119': 'Lurin',
      '150120': 'Magdalena del mar',
      '150121': 'Pueblo libre',
      '150122': 'Miraflores',
      '150123': 'Pachacamac',
      '150124': 'Pucusana',
      '150125': 'Puente piedra',
      '150126': 'Punta hermosa',
      '150127': 'Punta negra',
      '150128': 'Rimac',
      '150129': 'San bartolo',
      '150130': 'San borja',
      '150131': 'San isidro',
      '150132': 'San juan de lurigancho',
      '150133': 'San juan de miraflores',
      '150134': 'San luis',
      '150135': 'San martin de porres',
      '150136': 'San miguel',
      '150137': 'Santa anita',
      '150138': 'Santa maria del mar',
      '150139': 'Santa rosa',
      '150140': 'Santiago de surco',
      '150141': 'Surquillo',
      '150142': 'Villa el salvador',
      '150143': 'Villa maria del triunfo',
      '150200': 'Barranca',
      '150202': 'Paramonga',
      '150203': 'Pativilca',
      '150204': 'Supe',
      '150205': 'Supe puerto',
      '150300': 'Cajatambo',
      '150302': 'Copa',
      '150303': 'Gorgor',
      '150304': 'Huancapon',
      '150305': 'Manas',
      '150400': 'Canta',
      '150402': 'Arahuay',
      '150403': 'Huamantanga',
      '150404': 'Huaros',
      '150405': 'Lachaqui',
      '150406': 'San buenaventura',
      '150407': 'Santa rosa de quives',
      '150500': 'Cañete',
      '150501': 'San vicente de cañete',
      '150502': 'Asia',
      '150503': 'Calango',
      '150504': 'Cerro azul',
      '150505': 'Chilca',
      '150506': 'Coayllo',
      '150507': 'Imperial',
      '150508': 'Lunahuana',
      '150509': 'Mala',
      '150510': 'Nuevo imperial',
      '150511': 'Pacaran',
      '150512': 'Quilmana',
      '150513': 'San antonio',
      '150514': 'San luis',
      '150515': 'Santa cruz de flores',
      '150516': 'Zuñiga',
      '150600': 'Huaral',
      '150602': 'Atavillos alto',
      '150603': 'Atavillos bajo',
      '150604': 'Aucallama',
      '150605': 'Chancay',
      '150606': 'Ihuari',
      '150607': 'Lampian',
      '150608': 'Pacaraos',
      '150609': 'San miguel de acos',
      '150610': 'Santa cruz de andamarca',
      '150611': 'Sumbilca',
      '150612': 'Veintisiete de noviembre',
      '150700': 'Huarochiri',
      '150701': 'Matucana',
      '150702': 'Antioquia',
      '150703': 'Callahuanca',
      '150704': 'Carampoma',
      '150705': 'Chicla',
      '150706': 'Cuenca',
      '150707': 'Huachupampa',
      '150708': 'Huanza',
      '150709': 'Huarochiri',
      '150710': 'Lahuaytambo',
      '150711': 'Langa',
      '150712': 'Laraos',
      '150713': 'Mariatana',
      '150714': 'Ricardo palma',
      '150715': 'San andres de tupicocha',
      '150716': 'San antonio',
      '150717': 'San bartolome',
      '150718': 'San damian',
      '150719': 'San juan de iris',
      '150720': 'San juan de tantaranche',
      '150721': 'San lorenzo de quinti',
      '150722': 'San mateo',
      '150723': 'San mateo de otao',
      '150724': 'San pedro de casta',
      '150725': 'San pedro de huancayre',
      '150726': 'Sangallaya',
      '150727': 'Santa cruz de cocachacra',
      '150728': 'Santa eulalia',
      '150729': 'Santiago de anchucaya',
      '150730': 'Santiago de tuna',
      '150731': 'Santo domingo de los olleros',
      '150732': 'Surco',
      '150800': 'Huaura',
      '150801': 'Huacho',
      '150802': 'Ambar',
      '150803': 'Caleta de carquin',
      '150804': 'Checras',
      '150805': 'Hualmay',
      '150806': 'Huaura',
      '150807': 'Leoncio prado',
      '150808': 'Paccho',
      '150809': 'Santa leonor',
      '150810': 'Santa maria',
      '150811': 'Sayan',
      '150812': 'Vegueta',
      '150900': 'Oyon',
      '150902': 'Andajes',
      '150903': 'Caujul',
      '150904': 'Cochamarca',
      '150905': 'Navan',
      '150906': 'Pachangara',
      '151000': 'Yauyos',
      '151002': 'Alis',
      '151003': 'Allauca',
      '151004': 'Ayaviri',
      '151005': 'Azangaro',
      '151006': 'Cacra',
      '151007': 'Carania',
      '151008': 'Catahuasi',
      '151009': 'Chocos',
      '151010': 'Cochas',
      '151011': 'Colonia',
      '151012': 'Hongos',
      '151013': 'Huampara',
      '151014': 'Huancaya',
      '151015': 'Huangascar',
      '151016': 'Huantan',
      '151017': 'Huañec',
      '151018': 'Laraos',
      '151019': 'Lincha',
      '151020': 'Madean',
      '151021': 'Miraflores',
      '151022': 'Omas',
      '151023': 'Putinza',
      '151024': 'Quinches',
      '151025': 'Quinocay',
      '151026': 'San joaquin',
      '151027': 'San pedro de pilas',
      '151028': 'Tanta',
      '151029': 'Tauripampa',
      '151030': 'Tomas',
      '151031': 'Tupe',
      '151032': 'Viñac',
      '151033': 'Vitis',
    },
    "16": {
      '160000': 'Loreto',
      '160100': 'Maynas',
      '160101': 'Iquitos',
      '160102': 'Alto nanay',
      '160103': 'Fernando lores',
      '160104': 'Indiana',
      '160105': 'Las amazonas',
      '160106': 'Mazan',
      '160107': 'Napo',
      '160108': 'Punchana',
      '160109': 'Putumayo',
      '160110': 'Torres causana',
      '160112': 'Belen',
      '160113': 'San juan bautista',
      '160114': 'Teniente manuel clavero',
      '160200': 'Alto amazonas',
      '160201': 'Yurimaguas',
      '160202': 'Balsapuerto',
      '160205': 'Jeberos',
      '160206': 'Lagunas',
      '160210': 'Santa cruz',
      '160211': 'Teniente cesar lopez rojas',
      '160300': 'Loreto',
      '160301': 'Nauta',
      '160302': 'Parinari',
      '160303': 'Tigre',
      '160304': 'Trompeteros',
      '160305': 'Urarinas',
      '160400': 'Mariscal ramon castilla',
      '160401': 'Ramon castilla',
      '160402': 'Pebas',
      '160403': 'Yavari',
      '160404': 'San pablo',
      '160500': 'Requena',
      '160502': 'Alto tapiche',
      '160503': 'Capelo',
      '160504': 'Emilio san martin',
      '160505': 'Maquia',
      '160506': 'Puinahua',
      '160507': 'Saquena',
      '160508': 'Soplin',
      '160509': 'Tapiche',
      '160510': 'Jenaro herrera',
      '160511': 'Yaquerana',
      '160600': 'Ucayali',
      '160601': 'Contamana',
      '160602': 'Inahuaya',
      '160603': 'Padre marquez',
      '160604': 'Pampa hermosa',
      '160605': 'Sarayacu',
      '160606': 'Vargas guerra',
      '160700': 'Datem del marañon',
      '160701': 'Barranca',
      '160702': 'Cahuapanas',
      '160703': 'Manseriche',
      '160704': 'Morona',
      '160705': 'Pastaza',
      '160706': 'Andoas',
    },
    "17": {
      '170000': 'Madre de dios',
      '170100': 'Tambopata',
      '170102': 'Inambari',
      '170103': 'Las piedras',
      '170104': 'Laberinto',
      '170200': 'Manu',
      '170202': 'Fitzcarrald',
      '170203': 'Madre de dios',
      '170204': 'Huepetuhe',
      '170300': 'Tahuamanu',
      '170301': 'Iñapari',
      '170302': 'Iberia',
      '170303': 'Tahuamanu',
    },
    "18": {
      '180000': 'Moquegua',
      '180100': 'Mariscal nieto',
      '180101': 'Moquegua',
      '180102': 'Carumas',
      '180103': 'Cuchumbaya',
      '180104': 'Samegua',
      '180105': 'San cristobal',
      '180106': 'Torata',
      '180200': 'General sanchez cerro',
      '180201': 'Omate',
      '180202': 'Chojata',
      '180203': 'Coalaque',
      '180204': 'Ichuña',
      '180205': 'La capilla',
      '180206': 'Lloque',
      '180207': 'Matalaque',
      '180208': 'Puquina',
      '180209': 'Quinistaquillas',
      '180210': 'Ubinas',
      '180211': 'Yunga',
      '180300': 'Ilo',
      '180302': 'El algarrobal',
      '180303': 'Pacocha',
    },
    "19": {
      '190100': 'Pasco',
      '190101': 'Chaupimarca',
      '190102': 'Huachon',
      '190103': 'Huariaca',
      '190104': 'Huayllay',
      '190105': 'Ninacaca',
      '190106': 'Pallanchacra',
      '190107': 'Paucartambo',
      '190108': 'San francisco de asis de yarusyacan',
      '190109': 'Simon bolivar',
      '190110': 'Ticlacayan',
      '190111': 'Tinyahuarco',
      '190112': 'Vicco',
      '190113': 'Yanacancha',
      '190200': 'Daniel alcides carrion',
      '190201': 'Yanahuanca',
      '190202': 'Chacayan',
      '190203': 'Goyllarisquizga',
      '190204': 'Paucar',
      '190205': 'San pedro de pillao',
      '190206': 'Santa ana de tusi',
      '190207': 'Tapuc',
      '190208': 'Vilcabamba',
      '190300': 'Oxapampa',
      '190302': 'Chontabamba',
      '190303': 'Huancabamba',
      '190304': 'Palcazu',
      '190305': 'Pozuzo',
      '190306': 'Puerto bermudez',
      '190307': 'Villa rica',
      '190308': 'Constitucion',
    },
    "20": {
      '200100': 'Piura',
      '200104': 'Castilla',
      '200105': 'Catacaos',
      '200107': 'Cura mori',
      '200108': 'El tallan',
      '200109': 'La arena',
      '200110': 'La union',
      '200111': 'Las lomas',
      '200114': 'Tambo grande',
      '200200': 'Ayabaca',
      '200202': 'Frias',
      '200203': 'Jilili',
      '200204': 'Lagunas',
      '200205': 'Montero',
      '200206': 'Pacaipampa',
      '200207': 'Paimas',
      '200208': 'Sapillica',
      '200209': 'Sicchez',
      '200210': 'Suyo',
      '200300': 'Huancabamba',
      '200302': 'Canchaque',
      '200303': 'El carmen de la frontera',
      '200304': 'Huarmaca',
      '200305': 'Lalaquiz',
      '200306': 'San miguel de el faique',
      '200307': 'Sondor',
      '200308': 'Sondorillo',
      '200400': 'Morropon',
      '200401': 'Chulucanas',
      '200402': 'Buenos aires',
      '200403': 'Chalaco',
      '200404': 'La matanza',
      '200405': 'Morropon',
      '200406': 'Salitral',
      '200407': 'San juan de bigote',
      '200408': 'Santa catalina de mossa',
      '200409': 'Santo domingo',
      '200410': 'Yamango',
      '200500': 'Paita',
      '200502': 'Amotape',
      '200503': 'Arenal',
      '200504': 'Colan',
      '200505': 'La huaca',
      '200506': 'Tamarindo',
      '200507': 'Vichayal',
      '200600': 'Sullana',
      '200602': 'Bellavista',
      '200603': 'Ignacio escudero',
      '200604': 'Lancones',
      '200605': 'Marcavelica',
      '200606': 'Miguel checa',
      '200607': 'Querecotillo',
      '200608': 'Salitral',
      '200700': 'Talara',
      '200701': 'Pariñas',
      '200702': 'El alto',
      '200703': 'La brea',
      '200704': 'Lobitos',
      '200705': 'Los organos',
      '200706': 'Mancora',
      '200800': 'Sechura',
      '200802': 'Bellavista de la union',
      '200803': 'Bernal',
      '200804': 'Cristo nos valga',
      '200805': 'Vice',
      '200806': 'Rinconada llicuar',
    },
    "21": {
      '210100': 'Puno',
      '210102': 'Acora',
      '210103': 'Amantani',
      '210104': 'Atuncolla',
      '210105': 'Capachica',
      '210106': 'Chucuito',
      '210107': 'Coata',
      '210108': 'Huata',
      '210109': 'Mañazo',
      '210110': 'Paucarcolla',
      '210111': 'Pichacani',
      '210112': 'Plateria',
      '210113': 'San antonio',
      '210114': 'Tiquillaca',
      '210115': 'Vilque',
      '210200': 'Azangaro',
      '210202': 'Achaya',
      '210203': 'Arapa',
      '210204': 'Asillo',
      '210205': 'Caminaca',
      '210206': 'Chupa',
      '210207': 'Jose domingo choquehuanca',
      '210208': 'Muñani',
      '210209': 'Potoni',
      '210210': 'Saman',
      '210211': 'San anton',
      '210212': 'San jose',
      '210213': 'San juan de salinas',
      '210214': 'Santiago de pupuja',
      '210215': 'Tirapata',
      '210300': 'Carabaya',
      '210301': 'Macusani',
      '210302': 'Ajoyani',
      '210303': 'Ayapata',
      '210304': 'Coasa',
      '210305': 'Corani',
      '210306': 'Crucero',
      '210307': 'Ituata',
      '210308': 'Ollachea',
      '210309': 'San gaban',
      '210310': 'Usicayos',
      '210400': 'Chucuito',
      '210401': 'Juli',
      '210402': 'Desaguadero',
      '210403': 'Huacullani',
      '210404': 'Kelluyo',
      '210405': 'Pisacoma',
      '210406': 'Pomata',
      '210407': 'Zepita',
      '210500': 'El collao',
      '210501': 'Ilave',
      '210502': 'Capazo',
      '210503': 'Pilcuyo',
      '210504': 'Santa rosa',
      '210505': 'Conduriri',
      '210600': 'Huancane',
      '210602': 'Cojata',
      '210603': 'Huatasani',
      '210604': 'Inchupalla',
      '210605': 'Pusi',
      '210606': 'Rosaspata',
      '210607': 'Taraco',
      '210608': 'Vilque chico',
      '210700': 'Lampa',
      '210702': 'Cabanilla',
      '210703': 'Calapuja',
      '210704': 'Nicasio',
      '210705': 'Ocuviri',
      '210706': 'Palca',
      '210707': 'Paratia',
      '210708': 'Pucara',
      '210709': 'Santa lucia',
      '210710': 'Vilavila',
      '210800': 'Melgar',
      '210801': 'Ayaviri',
      '210802': 'Antauta',
      '210803': 'Cupi',
      '210804': 'Llalli',
      '210805': 'Macari',
      '210806': 'Nuñoa',
      '210807': 'Orurillo',
      '210808': 'Santa rosa',
      '210809': 'Umachiri',
      '210900': 'Moho',
      '210902': 'Conima',
      '210903': 'Huayrapata',
      '210904': 'Tilali',
      '211000': 'San antonio de putina',
      '211001': 'Putina',
      '211002': 'Ananea',
      '211003': 'Pedro vilca apaza',
      '211004': 'Quilcapuncu',
      '211005': 'Sina',
      '211100': 'San roman',
      '211101': 'Juliaca',
      '211102': 'Cabana',
      '211103': 'Cabanillas',
      '211104': 'Caracoto',
      '211200': 'Sandia',
      '211202': 'Cuyocuyo',
      '211203': 'Limbani',
      '211204': 'Patambuco',
      '211205': 'Phara',
      '211206': 'Quiaca',
      '211207': 'San juan del oro',
      '211208': 'Yanahuaya',
      '211209': 'Alto inambari',
      '211210': 'San pedro de putina punco',
      '211300': 'Yunguyo',
      '211302': 'Anapia',
      '211303': 'Copani',
      '211304': 'Cuturapi',
      '211305': 'Ollaraya',
      '211306': 'Tinicachi',
      '211307': 'Unicachi',
    },
    "22": {
      '220000': 'San martin',
      '220100': 'Moyobamba',
      '220102': 'Calzada',
      '220103': 'Habana',
      '220104': 'Jepelacio',
      '220105': 'Soritor',
      '220106': 'Yantalo',
      '220200': 'Bellavista',
      '220202': 'Alto biavo',
      '220203': 'Bajo biavo',
      '220204': 'Huallaga',
      '220205': 'San pablo',
      '220206': 'San rafael',
      '220300': 'El dorado',
      '220301': 'San jose de sisa',
      '220302': 'Agua blanca',
      '220303': 'San martin',
      '220304': 'Santa rosa',
      '220305': 'Shatoja',
      '220400': 'Huallaga',
      '220401': 'Saposoa',
      '220402': 'Alto saposoa',
      '220403': 'El eslabon',
      '220404': 'Piscoyacu',
      '220405': 'Sacanche',
      '220406': 'Tingo de saposoa',
      '220500': 'Lamas',
      '220502': 'Alonso de alvarado',
      '220503': 'Barranquita',
      '220504': 'Caynarachi',
      '220505': 'Cuñumbuqui',
      '220506': 'Pinto recodo',
      '220507': 'Rumisapa',
      '220508': 'San roque de cumbaza',
      '220509': 'Shanao',
      '220510': 'Tabalosos',
      '220511': 'Zapatero',
      '220600': 'Mariscal caceres',
      '220601': 'Juanjui',
      '220602': 'Campanilla',
      '220603': 'Huicungo',
      '220604': 'Pachiza',
      '220605': 'Pajarillo',
      '220700': 'Picota',
      '220702': 'Buenos aires',
      '220703': 'Caspisapa',
      '220704': 'Pilluana',
      '220705': 'Pucacaca',
      '220706': 'San cristobal',
      '220707': 'San hilarion',
      '220708': 'Shamboyacu',
      '220709': 'Tingo de ponasa',
      '220710': 'Tres unidos',
      '220800': 'Rioja',
      '220802': 'Awajun',
      '220803': 'Elias soplin vargas',
      '220804': 'Nueva cajamarca',
      '220805': 'Pardo miguel',
      '220806': 'Posic',
      '220807': 'San fernando',
      '220808': 'Yorongos',
      '220809': 'Yuracyacu',
      '220900': 'San martin',
      '220901': 'Tarapoto',
      '220902': 'Alberto leveau',
      '220903': 'Cacatachi',
      '220904': 'Chazuta',
      '220905': 'Chipurana',
      '220906': 'El porvenir',
      '220907': 'Huimbayoc',
      '220908': 'Juan guerra',
      '220909': 'La banda de shilcayo',
      '220910': 'Morales',
      '220911': 'Papaplaya',
      '220912': 'San antonio',
      '220913': 'Sauce',
      '220914': 'Shapaja',
      '221000': 'Tocache',
      '221002': 'Nuevo progreso',
      '221003': 'Polvora',
      '221004': 'Shunte',
      '221005': 'Uchiza',
    },
    "23": {
      '230100': 'Tacna',
      '230101': 'Tacna',
      '230102': 'Alto de la alianza',
      '230103': 'Calana',
      '230104': 'Ciudad nueva',
      '230105': 'Inclan',
      '230106': 'Pachia',
      '230107': 'Palca',
      '230108': 'Pocollay',
      '230109': 'Sama',
      '230110': 'Coronel gregorio albarracin lanchipa',
      '230200': 'Candarave',
      '230202': 'Cairani',
      '230203': 'Camilaca',
      '230204': 'Curibaya',
      '230205': 'Huanuara',
      '230206': 'Quilahuani',
      '230300': 'Jorge basadre',
      '230301': 'Locumba',
      '230302': 'Ilabaya',
      '230303': 'Ite',
      '230400': 'Tarata',
      '230402': 'Heroes albarracin',
      '230403': 'Estique',
      '230404': 'Estique-pampa',
      '230405': 'Sitajara',
      '230406': 'Susapaya',
      '230407': 'Tarucachi',
      '230408': 'Ticaco',
    },
    "24": {
      '240100': 'Tumbes',
      '240102': 'Corrales',
      '240103': 'La cruz',
      '240104': 'Pampas de hospital',
      '240105': 'San jacinto',
      '240106': 'San juan de la virgen',
      '240200': 'Contralmirante villar',
      '240201': 'Zorritos',
      '240202': 'Casitas',
      '240203': 'Canoas de punta sal',
      '240300': 'Zarumilla',
      '240302': 'Aguas verdes',
      '240303': 'Matapalo',
      '240304': 'Papayal',
    },
    "25": {
      '250000': 'Ucayali',
      '250100': 'Coronel portillo',
      '250101': 'Calleria',
      '250102': 'Campoverde',
      '250103': 'Iparia',
      '250104': 'Masisea',
      '250105': 'Yarinacocha',
      '250106': 'Nueva requena',
      '250107': 'Manantay',
      '250200': 'Atalaya',
      '250201': 'Raymondi',
      '250202': 'Sepahua',
      '250203': 'Tahuania',
      '250204': 'Yurua',
      '250300': 'Padre abad',
      '250302': 'Irazola',
      '250303': 'Curimana',
      '250400': 'Purus',
    }
  }

  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}


